export const PHONE_DISPLAY = '+90 542 799 47 89';
export const PHONE_TEL = '+905427994789';
export const WHATSAPP_NUMBER = '905427994789';
export const INSTAGRAM_HANDLE = '@villagarage90';
export const INSTAGRAM_URL = 'https://www.instagram.com/villagarage90';
export const WHATSAPP_BASE = 'https://wa.me/' + WHATSAPP_NUMBER;

/** App base path, injected by Vite. */
export const BASE_PATH = __BASE_PATH__;

/** Prefixes an internal path with the app base path (keeps basename working). */
export function withBase(path: string): string {
  const base = BASE_PATH.endsWith('/') ? BASE_PATH.slice(0, -1) : BASE_PATH;
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${base}${suffix}`;
}